import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/store/appstate';
import { Logger, LoggerOptions, LoggerOptionsService } from './logger';
import { ErrorLogEntry, InformationLogEntry, WarningLogEntry } from './ngrx-store-logger-actions';

@Injectable()
export class NgrxStoreLogger implements Logger {
  constructor(private _store: Store<AppState>, private _optionsManager: LoggerOptionsService) {}

  public error(
    error: Error | string,
    properties?: { [name: string]: string },
    options?: LoggerOptions,
  ) {
    if (this._optionsManager.canLogToNgrxStore(options)) {
      this._store.dispatch(new ErrorLogEntry(error, properties));
    }
  }
  public info(message: string, properties?: { [name: string]: string }, options?: LoggerOptions) {
    if (this._optionsManager.canLogToNgrxStore(options)) {
      this._store.dispatch(new InformationLogEntry(message, properties));
    }
  }
  public warning(
    message: string,
    properties?: { [name: string]: string },
    options?: LoggerOptions,
  ) {
    if (this._optionsManager.canLogToNgrxStore(options)) {
      this._store.dispatch(new WarningLogEntry(message, properties));
    }
  }
}
